import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { VendorLookupResponse } from '@/types/tenant.types';
import { authAPI } from '@/services/auth.service';
import { OnboardingData } from '@/schemas/onboarding.schema';
import { VendorOnboardingResponse } from '@/types';
import { useNavigate } from 'react-router-dom';
import { handleAnyError } from '@/lib/utils';

export function useGetVendor() {
  return useQuery({
    queryKey: ['vendor-me'],
    queryFn: () => authAPI.getProfile(),
  });
}



export const useVendorLookup = () => {
  return useMutation<VendorLookupResponse, Error, string>({
    mutationFn: (email: string) => authAPI.vendorLookup({ email }),
    onSuccess: (response) => {
      if (!response.data?.tenants?.length) {
        toast.error('No tenant found for this email');
      }
    },
    onError: handleAnyError,
  });
};

export const useVendorOnboarding = () => {
  const navigate = useNavigate()
  return useMutation<VendorOnboardingResponse, Error, OnboardingData>({
    mutationFn: (data: OnboardingData) => authAPI.completeOnboarding(data),

    onSuccess: () => {
      toast.success('Onboarding completed successfully!');
      navigate("/dashboard")
    },

    onError: handleAnyError,
  });
};
